export enum ComplianceExperienceId {
  V0 = 'v0',
  V1 = 'v1',
  V2 = 'v2',
}

export const parseComplianceExperienceId = (
  value: unknown,
): ComplianceExperienceId => {
  if (
    value === ComplianceExperienceId.V0 ||
    value === ComplianceExperienceId.V1 ||
    value === ComplianceExperienceId.V2
  ) {
    return value;
  }

  return ComplianceExperienceId.V2;
};
